<template>
  <div class="is-full-width is-relative is-flex-centered">
    <div is-add-more-button-background class="is-absolute has-background-white"></div>
    <ButtonView
      :loading="isLoading"
      type="is-ghost"
      class="is-shadowless is-borderless"
      @click.stop="onLoadMore()"
      :data-e2e="FormCypressAttribute.buttons.LOAD_MORE"
    >
      {{ $t('ui.load-more') }}
    </ButtonView>
  </div>
</template>

<script>
import { FormCypressAttribute } from '@/modules/core/form/constants/FormCypressAttribute';
import ButtonView from '@/modules/core/ui/components/wrappers/ButtonView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'FormMultiSelectLoadMoreSection',
  emits: ['on-load-more'],
  components: { ButtonView },
  props: {
    config: {
      type: Object,
      required: true
    },
    option: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  static: {
    FormCypressAttribute
  },
  methods: {
    onLoadMore() {
      this.$emit('on-load-more', this.option);
    }
  }
};
</script>

<style scoped>
[type='is-ghost'] {
  height: var(--ce-25px);
}
[is-add-more-button-background] {
  cursor: initial;
  top: -10px;
  left: -10px;
  right: -10px;
  bottom: -10px;
}
</style>
